import { useSearch } from '@tanstack/react-router';
import { useInitializeFilters } from '../hooks/use-initialize-filters';
import { AppointmentAnalyticsV2ViewContainer } from './views/charts-view';
import { CompareLocationsView } from './views/compare-locations-view';
import { ProspectPatientListView } from './views/prospect-patient-list-view';
import { ScheduleRequestsView } from './views/schedule-request-table-view';

export const AppointmentAnalyticsV2 = () => {
  const { comparingLocations, customTableView } = useSearch({ from: '/analytics/appointment' });

  useInitializeFilters();

  if (comparingLocations) {
    return <CompareLocationsView />;
  }

  if (customTableView === 'prospect-list') {
    return <ProspectPatientListView />;
  }

  if (customTableView === 'schedule-requests') {
    return <ScheduleRequestsView />;
  }

  return <AppointmentAnalyticsV2ViewContainer />;
};
